import { valueToBigNumber } from './bignumber';

export const SECONDS_PER_YEAR = valueToBigNumber('31536000');
export const BCH_DECIMALS = 18;
export const USD_DECIMALS = 10;
export const RAY_DECIMALS = 27;
